import moment = require("moment");
import _ = require("lodash");
import { ComplianceRepo } from "./compliance.repo";
import { IOnInit } from "angular";
import { AuditPerformanceParameter } from "./models/auditPerformanceParameter ";

class ComplianceController implements IOnInit {
  public cashTransactions: Array<any>;
  public isLoadingCashTransactions;

  public toDate;
  public fromDate;
  public currentDate: Date;
  public cashTransactionsGridOptions;
  public displayCashTransactionCard = false;

  public performanceParameters: Array<any>;
  public isLoadingPerformanceParameters;
  public performanceParametersGridOptions;
  public displayPerformanceParameterCard = true;

  public tradingRestrictions: Array<any>;
  public isLoadingTradingRestrictions;
  public tradingRestrictionsGridOptions;
  public displayTradingRestrictionCard = true;

  public feeExclusions: Array<any>;
  public isLoadingFeeExclusions;
  public feeExclusionsGridOptions;
  public displayFeeExclusionCard = true;

  public clientFees: Array<any>;
  public isLoadingClientFees;
  public clientFeesGridOptions;
  public displayClientFeeCard = true;

  public cmodels: Array<any>;
  public isLoadingCmodels;
  public cmodelsGridOptions;
  public displayCmodelCard = true;

  /** @ngInject */
  constructor(
    private $scope: angular.IScope,
    private complianceRepo: ComplianceRepo,
    private notifyjs,
    private $state: angular.ui.IStateService,
    private $window: angular.IWindowService
  ) {
    this.currentDate = new Date();

    if (_.isEmpty(this.fromDate) || _.isEmpty(this.toDate)) {
      this.fromDate = new Date(
        moment(this.currentDate).subtract(1, "months").toString()
      ); //;
      this.toDate = this.currentDate;
    }

    this.cashTransactionsGridOptions = this.$scope[
      "cashTransactionsGridOptions"
    ] = {
      data: [],
      urlSync: false,
    };

    this.performanceParametersGridOptions = this.$scope[
      "performanceParametersGridOptions"
    ] = {
      data: [],
      urlSync: false,
    };

    this.tradingRestrictionsGridOptions = this.$scope[
      "tradingRestrictionsGridOptions"
    ] = {
      data: [],
      urlSync: false,
    };

    this.feeExclusionsGridOptions = this.$scope["feeExclusionsGridOptions"] = {
      data: [],
      urlSync: false,
    };

    this.clientFeesGridOptions = this.$scope["clientFeesGridOptions"] = {
      data: [],
      urlSync: false,
    };
    this.cmodelsGridOptions = this.$scope["cmodelsGridOptions"] = {
      data: [],
      urlSync: false,
    };
  }

  $onInit = () => {
    this.updateData();
  };

  fromDateChanged = () => {
    if (this.fromDate < this.toDate) {
      this.updateData();
    }
  };

  toDateChanged = () => {
    this.updateData();
  };

  updateData = () => {
    this.getCashTransactions();
    this.getPerformanceParameters();
    this.getTradingRestrictions();
    this.getFeeExclusions();
    this.getClientFees();
    this.getCModels();
  };

  getAllAuditData = () => {
    this.fromDate = moment("2018-01-01").format("YYYY-MM-DD");
    this.toDate = this.currentDate;
    this.updateData();
  };

  getCashTransactions = () => {
    this.isLoadingCashTransactions = true;
    this.complianceRepo
      .getCashTransactions(this.fromDate, this.toDate)
      .then((res) => {
        this.cashTransactions = res.data as Array<any>;
        this.cashTransactionsGridOptions.data = this.cashTransactions;
      })
      .catch((err) => {
        this.notifyjs(
          "Failed to load cash transactions for the selected date " + err.data
        );
      })
      .finally(() => {
        this.isLoadingCashTransactions = false;
        this.displayCashTransactionCard = true;
      });
  };

  getLocalDateTime = (utcDate) => {
    return moment.utc(utcDate).local().format("DD-MM-YYYY HH:mm:ss");
  };

  goToClient = ($event, item) => {
    $event.stopPropagation();
    var url = this.$state.href("root.portfolioManagement.clients.portfolio", {
      clientNumber: item.clientNumber,
    });
    this.$window.open(url, "_blank");
  };

  getCashTransactionHistory = (item) => {
    if (item.transactionHistory == null) {
      this.complianceRepo
        .getCashTransactionHistory(item.id)
        .then((res) => {
          item.transactionHistory = res.data as Array<any>;
        })
        .catch((err) => {
          this.notifyjs(
            "Could not find history for the selected cash transaction " +
              err.data
          );
        });
    }
  };

  getPerformanceParameters = () => {
    this.isLoadingPerformanceParameters = true;
    this.complianceRepo
      .getPerformanceParameters(this.fromDate, this.toDate, "MUR")
      .then((res) => {
        this.performanceParameters =
          res.data as Array<AuditPerformanceParameter>;
        this.performanceParametersGridOptions.data = this.performanceParameters;
      })
      .catch((err) => {
        this.notifyjs("Failed to load performance values " + err.data);
      })
      .finally(() => {
        this.isLoadingPerformanceParameters = false;
        this.displayPerformanceParameterCard = true;
      });
  };

  getLocalityText = (locality) => {
    return locality == 0
      ? "Local"
      : locality == 1
      ? "International"
      : locality == "2"
      ? "Combined"
      : "";
  };

  getBoolToText = (val) => {
    return val ? "Yes" : "No";
  };

  getPercentageValue = (performance) => {
    return +(performance * 100).toFixed(2);
  };

  getPerformanceParameterHistory = (performanceParamater) => {
    if (performanceParamater.performanceHistory == null) {
      this.complianceRepo
        .getPerformanceParametersHistory(
          performanceParamater.id,
          performanceParamater.portfolioId,
          performanceParamater.performanceDate
        )
        .then((res) => {
          performanceParamater.performanceHistory = res.data as Array<any>;
        })
        .catch((err) => {
          this.notifyjs("Failed to get performance history " + err.data);
        });
    }
  };

  getTradingRestrictions = () => {
    this.isLoadingTradingRestrictions = true;
    this.complianceRepo
      .getTradingRestrictions(this.fromDate, this.toDate)
      .then((res) => {
        this.tradingRestrictions = res.data as Array<any>;
        this.tradingRestrictionsGridOptions.data = this.tradingRestrictions;
      })
      .catch((err) => {
        this.notifyjs("Failed to load trading restrictions " + err.data);
      })
      .finally(() => {
        this.isLoadingTradingRestrictions = false;
        this.displayTradingRestrictionCard = true;
      });
  };

  getRestrictionTypeText = (restriction) => {
    if (restriction.noBuy && restriction.noSell) {
      return "Can not be bought or sold";
    }

    if (restriction.noBuy) {
      return "Can not be bought";
    }

    if (restriction.noSell) {
      return "Can not be sold";
    }

    if (restriction.percentageOfPortfolio) {
      return `Must be between ${restriction.minPortfolio}% and ${restriction.maxPortfolio}% of overall portfolio`;
    }

    return "No trade restriction";
  };

  getTradingRestrictionHistory = (restriction) => {
    if (restriction.restrictionHistory == null) {
      this.complianceRepo
        .getTradingRestrictionHistory(restriction.id)
        .then((res) => {
          restriction.restrictionHistory = res.data as Array<any>;
        })
        .catch((err) => {
          this.notifyjs("Failed to load restriction history " + err.data);
        });
    }
  };

  getFeeExclusions = () => {
    this.isLoadingFeeExclusions = true;
    this.complianceRepo
      .getFeeExclusions(this.fromDate, this.toDate)
      .then((res) => {
        this.feeExclusions = res.data as Array<any>;
        this.feeExclusionsGridOptions.data = this.feeExclusions;
      })
      .catch((err) => {
        this.notifyjs("Failed to load trading restrictions " + err.data);
      })
      .finally(() => {
        this.isLoadingFeeExclusions = false;
        this.displayFeeExclusionCard = true;
      });
  };

  getFeeExclusionHistory = (feeExclusion) => {
    if (feeExclusion.feeExclusionHistory == null) {
      this.complianceRepo
        .getFeeExclusionHistory(feeExclusion.id)
        .then((res) => {
          feeExclusion.feeExclusionHistory = res.data as Array<any>;
        })
        .catch((err) => {
          this.notifyjs(
            "Failed to get history for selected fee exclusion " + err.data
          );
        });
    }
  };

  getClientFees = () => {
    this.isLoadingClientFees = true;
    this.complianceRepo
      .getClientFees(this.fromDate, this.toDate)
      .then((res) => {
        this.clientFees = res.data as Array<any>;
        this.clientFeesGridOptions.data = this.clientFees;
      })
      .catch((err) => {
        this.notifyjs("Failed to load trading restrictions " + err.data);
      })
      .finally(() => {
        this.isLoadingClientFees = false;
        this.displayClientFeeCard = true;
      });
  };

  getClientFeeHistory = (clientFee) => {
    if (clientFee.clientFeeHistory == null) {
      this.complianceRepo
        .getClientFeeHistory(clientFee.portfolioFeeId)
        .then((res) => {
          clientFee.clientFeeHistory = res.data as Array<any>;
        })
        .catch((err) => {
          this.notifyjs(
            "Failed to get history for selected client fee " + err.data
          );
        });
    }
  };

  getCModels = () => {
    this.isLoadingCmodels = true;
    this.complianceRepo
      .getCModels(this.fromDate, this.toDate)
      .then((res) => {
        this.cmodels = res.data as Array<any>;
      })
      .catch((err) => {
        this.notifyjs("Could not get Cmodels " + err.data);
      })
      .finally(() => {
        this.isLoadingCmodels = false;
        this.displayCmodelCard = true;
      });
  };

  goToCmodel = ($event) => {
    $event.stopPropagation();
    var url = this.$state.href("root.cmodel.mauritius");
    this.$window.open(url, "_blank");
  };

  getCmodelTotalMarketValue = (cmodel) => {
    return cmodel.items.reduce((prev, next) => {
      return prev + next.quantity * next.price;
    }, 0);
  };

  getRestrictionDescription = (restriction) => {
    if (restriction.securityName !== "") {
      return restriction.description;
    } else {
      return restriction.assetClassName;
    }
  };
}

export const compliance: angular.IComponentOptions = {
  template: require("./compliance.component.html"),
  controller: ComplianceController,
};



// WEBPACK FOOTER //
// ./src/app/compliance/compliance.component.ts